module.exports = __webpack_public_path__ + "static/media/bB.cb69fc1a.svg";